import styled from "styled-components";

export const StyledHowItWorks = styled("section")(
  ({ theme }) => `
  background: linear-gradient(135deg, #c7a5fc 0%, #9884fc 50%, #6ba5fc 100%);
  color: ${theme.colorBgContainer};
  padding-block: 64px;
  padding-inline: 45px;
  position: relative;
  overflow: hidden;
`,
);

export const GradientBlob1 = styled("div")`
  position: absolute;
  top: 0;
  left: 0;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(99, 102, 241, 0.25) 0%, rgba(168, 85, 247, 0.15) 40%, transparent 70%);
  filter: blur(80px);
`;

export const GradientBlob2 = styled("div")`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, transparent 60%);
  filter: blur(70px);
`;

export const ContentContainer = styled("div")`
  position: relative;
  z-index: 1;
`;

export const HeaderContainer = styled("div")`
  text-align: center;
  margin-bottom: 40px;
`;

export const SectionTitle = styled("h2")(
  ({ theme }) => `
  color: ${theme.colorBgContainer};
  font-weight: 700;
  margin-bottom: 8px;
  font-size: 32px;
`,
);

export const SectionSubtitle = styled("p")`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
`;

export const StepCard = styled("div")`
  position: relative;
`;

export const StepNumber = styled("h1")`
  position: absolute;
  top: -32px;
  left: -16px;
  font-size: 72px;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.1);
  z-index: 0;
  margin: 0;
`;

export const StepContent = styled("div")`
  position: relative;
  z-index: 1;
`;

export const StepTitle = styled("h4")(
  ({ theme }) => `
  color: ${theme.colorBgContainer};
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
`,
);

export const StepDescription = styled("p")`
  color: rgba(255, 255, 255, 0.8);
  font-size: 15px;
`;
